<template>
  <div id="myAccountWrapper">
    <div class="columns">
      <div class="column is-half">
        <my-title>Mijn accountgegevens</my-title>

        <div v-show="saved" class="notification is-success">
          Je wijzigingen zijn opgeslagen!
        </div>

        <div class="box">
          <div class="field">
            <label class="label">Voornaam</label>
            <div class="control">
              <input class="input" type="text" v-model="firstname">
            </div>
          </div>

          <div class="field">
            <label class="label">Achternaam</label>
            <div class="control">
              <input class="input" type="text" v-model="lastname">
            </div>
          </div>

          <div class="field">
            <label class="label">E-mail adres</label>
            <div class="control">
              <input class="input" type="text" v-model="email">
            </div>
          </div>

          <save-buttons
            @save="save"
            :noCancel="true"
            saveCaption="Gegevens opslaan">
          </save-buttons>
        </div>

        <reset-password></reset-password>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MyTitle from '@/components/modules/Title'
import SaveButtons from '@/components/modules/SaveButtons'
import ResetPassword from '@/components/accounts/ResetPassword'

export default {
  components: {
    MyTitle,
    SaveButtons,
    ResetPassword
  },
  data () {
    return {
      firstname: null,
      lastname: null,
      email: null
    }
  },
  computed: {
    ...mapGetters({
      saved: 'account/saved',
      account: 'account/account'
    })
  },
  created () {
    this.setData()
  },
  watch: {
    account () {
      this.setData()
    }
  },
  methods: {
    setData () {
      this.firstname = this.account.firstname
      this.lastname = this.account.lastname
      this.email = this.account.email
    },
    save () {
      this.$store.dispatch('account/save', {
        firstname: this.firstname,
        lastname: this.lastname,
        email: this.email
      })
    }
  }
}
</script>
